import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'simlab-callback',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class CallbackComponent {}
